<template>
  <b-input-group>
    <b-input
      :value="recipient.name"
      type="text"
      required
      placeholder="Mark Houser"
      @focus.native="activeSearch = true"
      @focusout.native="hideSearch"
      @keyup.native="search"/>
    <b-input-group-text slot="append">
      <img
        src="~@/assets/img/search-icon-light.svg"
        alt="Search"
        width="14px"
        height="14px">
    </b-input-group-text>
    <ul
      :class="{'active' : activeSearch}"
      class="search-results">
      <li
        v-for="contact in recipientList"
        :key="contact.id"
        @click="selectFbRecipient(contact)">
        {{ contact.name }}
      </li>
      <li
        v-if="!recipientList.length"
        class="no-results">
        No results found.
      </li>
    </ul>
  </b-input-group>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'FbRecipientSearch',
  data() {
    return {
      activeSearch: false,
      recipientList: [],
      recipient: {
        name: '',
        id: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      merchantFbRecipients: 'merchant/merchantFbRecipients',
      foundFbRecipients: 'merchant/foundFbRecipients',
    }),
  },
  watch: {
    merchantFbRecipients(payload) {
      this.recipientList = payload.data;
    },
    foundFbRecipients(payload) {
      this.recipientList = payload.data;
    },
  },
  mounted() {
    this.fetchFbRecipients(this.$route.params.merchant_id);
  },
  methods: {
    ...mapActions({
      fetchFbRecipients: 'merchant/fetchFacebookRecipients',
      searchFbRecipients: 'merchant/searchFacebookRecipients',
    }),
    selectFbRecipient(recipient) {
      this.recipient = recipient;
      this.$emit('selectFbRecipient', recipient);
    },
    search(e) {
      const name = e.target.value;
      if (name.length === 0) {
        this.recipientList = this.merchantFbRecipients.data;
        return;
      }
      this.searchFbRecipients({
        merchant_id: this.$route.params.merchant_id,
        name,
      });
    },
    hideSearch(e) {
      e.target.value = this.recipient.name;
      setTimeout(() => {
        this.activeSearch = false;
      }, 100);
    },
  },
};
</script>
